// extracted by mini-css-extract-plugin
export var container = "newsletter-module--container--VlC0z";
export var text = "newsletter-module--text--oVmSU";
export var errorText = "newsletter-module--errorText--KwutR";
export var form = "newsletter-module--form--l13TY";
export var completeStep = "newsletter-module--completeStep--Mu7+X";
export var submitBtnContainer = "newsletter-module--submitBtnContainer--Jh0zM";
export var slideUp = "newsletter-module--slideUp--4PAu6";
export var slideUpLarge = "newsletter-module--slideUpLarge--TlLaU";